import { RequestService } from '../../../../../common/services/RequestService';
import { DELETE_REQUEST } from '../constants';

export const deleteRequestRequest = payload => {
  return RequestService.delete(DELETE_REQUEST + `/${payload}`);
};
